import React, {useContext, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {SVGICONS} from '@ey/icons';
import styled from 'styled-components';
import {mapsIcTraffic24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {labels} from '../../../../util/utils';
import SectionRelatedObjectItem from './SectionRelatedObjectItem';
import {getSectionRelatedObjects} from '../../../../actions/RelatedObjects/relatedobjectsactions';
import {DocumentEngagementIdContext, DocumentEntityIdContext} from '../../../Main/Forms/CanvasFormContainer';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import CompareSnapshotLabel from '../CompareSnapshotLabel';
import ManageObjectsModal from './ManageObjects/ManageSectionObjectsModal';
import {entities, clientSideEventNames} from '../../../../util/uiconstants';
import {GetSectionRelatedObjectTreeForChildToParent} from '../../../../reducers/SectionRelatedObjects/sectionrelatedobjectsreducer';
import useIsMountedRef from '../../../../util/isMountedRef';
import Icon from '../../BaseComponentWrappers/MotifIcon';
import {IconoirMinus, IconoirPlus} from '@ey-xd/motif-icon';
import _ from 'lodash';
import {useDocumentId, useEngagementId, useUserPreferences} from '../../../../util/customHooks';
import {IconoirCustomRiskBolt} from '@ey/motif-react-wrapper/assets/icons/custom';

export default function SectionRelatedObjects(props) {
	const {sectionId, isSnapshotView, formSectionRelatedObjects, section} = props;
	const isMountedRef = useIsMountedRef();
	let snapshotLabel = {isChanged: 'isChanged'};

	const [relatedObjectExpanded, setRelatedObjectExpanded] = useState(false),
		[totalParentsCount, setTotalParentsCount] = useState(0),
		[isfsroUpdated, setIsFSROUpdated] = useState(false),
		[isLoading, setIsLoading] = useState(false),
		[sectionsRelatedObjectsWithEntity, setSectionsRelatedObjectsWithEntity] = useState([]),
		[currentStateSectionsRelatedObjects, setCurrentStateSectionsRelatedObjects] = useState([]),
		[totalChildrenCount, setTotalChildrenCount] = useState(0),
		[showModal, setShowManageObjectsModal] = useState(false),
		[isTargetEng, setIsTargetEng] = useState(false);

	const documentId = useDocumentId(),
		engagementId = useEngagementId(),
		documentEngagementId = useContext(DocumentEngagementIdContext),
		userPreferences = useUserPreferences(),
		documentEntityId = useContext(DocumentEntityIdContext);

	const sectionRelatedObjects = useSelector((store) => store.sectionRelatedObjects[props.sectionId]);
	const dispatch = useDispatch();

	const GetSectionRelatedObjectTree = (sectionsRelatedObjectReadModelList) => {
		if (sectionsRelatedObjectReadModelList !== undefined && sectionsRelatedObjectReadModelList.length > 0) {
			let sectionRelatedParentObjects = [];

			return BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionsRelatedObjectReadModelList, 1);
		}

		function BuildSectionRelatedObjectTree(sectionRelatedParentObjects, sectionRelatedObjectList, level) {
			let sectionRelatedObjectsModel = [];
			if (sectionRelatedObjectList !== undefined && sectionRelatedObjectList.length > 0) {
				sectionRelatedObjectList.map((parentObject) => {
					parentObject.children = [];
					let fsro = _.cloneDeep(parentObject);
					if (!isfsroUpdated) {
						if (fsro.isAdded || fsro.isChanged || fsro.isDeleted) {
							setIsFSROUpdated(true);
						}
					}
					let sectionRelatedChildObject = sectionRelatedObjectList.filter(
						(obj) => obj.parentEntityId === parentObject.entityId && obj.parentEntityUId === parentObject.entityUId
					);
					//fsro.children = [];

					if (sectionRelatedChildObject !== undefined && sectionRelatedChildObject.length > 0) {
						// Recursive function call to get child for given parent
						fsro.children = BuildSectionRelatedObjectTree(
							sectionRelatedParentObjects,
							sectionRelatedChildObject,
							level + 1
						);
					}
					if (sectionRelatedParentObjects && sectionRelatedParentObjects.length > 0) {
						let abc = sectionRelatedParentObjects.filter((obj) => obj.entityUId === fsro.entityUId);
						if (abc && abc.length === 0) {
							sectionRelatedObjectsModel.push(fsro);
							sectionRelatedParentObjects.push(fsro);
						}
					} else {
						sectionRelatedObjectsModel.push(fsro);
						sectionRelatedParentObjects.push(fsro);
					}
				});
			}
			return sectionRelatedObjectsModel;
		}
	};

	const getAllSectionRelatedObjects = (includeEntityName) => {
		if (!isSnapshotView) {
			setIsLoading(true);
			dispatch(getSectionRelatedObjects(documentId, engagementId, sectionId, includeEntityName)).finally(() => {
				if (isMountedRef) {
					setIsLoading(false);
				}
			});
		} else {
			if (formSectionRelatedObjects && formSectionRelatedObjects.length > 0) {
				// TODO -> Make this common for FSROs in the Form and Changes views
				let newState = [];
				let fsroTreeList;
				newState = _.cloneDeep(formSectionRelatedObjects);

				if (
					newState.some(
						(parent) => parent.parentEntityId === entities.Control && parent.entityId === entities.ItSoApplication
					)
				) {
					fsroTreeList = GetSectionRelatedObjectTreeForChildToParent(newState);
				} else {
					fsroTreeList = GetSectionRelatedObjectTree(newState);
				}

				let fsroParentCount = fsroTreeList.length;
				let fsroChildCount = formSectionRelatedObjects.length - fsroParentCount;

				// Specific logic for Control -> IT App FSRO
				if (documentEntityId === entities.Control) {
					setTotalParentsCount(fsroChildCount);
				} else {
					setTotalParentsCount(fsroParentCount);
				}

				setTotalChildrenCount(fsroChildCount);

				if (includeEntityName) {
					setSectionsRelatedObjectsWithEntity(fsroTreeList);
				} else {
					setSectionsRelatedObjectsWithEntity([]);
				}
			}
		}
	};

	const relatedObjectExpandCollapse = () => {
		setRelatedObjectExpanded(!relatedObjectExpanded);
		if (!relatedObjectExpanded === true) {
			getAllSectionRelatedObjects(true);
		}
	};

	const relatedObjectExpand = () => {
		setRelatedObjectExpanded(true);
		getAllSectionRelatedObjects(true);
	};

	const closeModal = () => {
		setShowManageObjectsModal(false);
		if (
			JSON.stringify(sectionsRelatedObjectsWithEntity) !== JSON.stringify(currentStateSectionsRelatedObjects) &&
			relatedObjectExpanded
		) {
			getAllSectionRelatedObjects(true);
		}
	};

	const loadManageObjectModel = () => {
		setShowManageObjectsModal(true);
		setCurrentStateSectionsRelatedObjects(sectionsRelatedObjectsWithEntity);
	};

	useEffect(() => {
		if (!isSnapshotView && sectionRelatedObjects) {
			setTotalParentsCount(Number(sectionRelatedObjects.fsroParentCount));
			setTotalChildrenCount(Number(sectionRelatedObjects.fsroChildCount));
			if (relatedObjectExpanded) {
				setSectionsRelatedObjectsWithEntity([...sectionRelatedObjects.fsroTreeList]);
			}
		}
	}, [sectionRelatedObjects]);

	useEffect(() => {
		getAllSectionRelatedObjects(false);
		window.addEventListener(clientSideEventNames.relatedObjectExpand, relatedObjectExpand);
		return () => {
			window.removeEventListener(clientSideEventNames.relatedObjectExpand, relatedObjectExpand);
		};
	}, []);

	useEffect(() => {
		if (documentEngagementId !== undefined) {
			if (Number(engagementId) !== Number(documentEngagementId)) {
				setIsTargetEng(true);
			}
		}
	}, [documentEngagementId]);

	return (
		<RelatedObjectWrapper className="RelatedObjectWrapperContainer" key={`${section.id}-fsro`}>
			<section className={`accordionWrapper ${relatedObjectExpanded ? 'selected-accordion' : ''}`}>
				<section className="relatedObject-Wrapper">
					<section className="relatedObject-container" onClick={relatedObjectExpandCollapse}>
						<section className="plusminusIcons" title={!relatedObjectExpanded ? labels.expand : labels.collapse}>
							<Icon
								className={`medium`}
								src={!relatedObjectExpanded ? IconoirPlus : IconoirMinus}
								title={!relatedObjectExpanded ? labels.expand : labels.collapse}
							/>
						</section>
						<section className="relatedObjectsText">{labels.relatedObjects}</section>
					</section>
					<section className="relatedObjectRight">
						{documentEntityId === entities.SCOT && (
							<section className="relatedObjectRight">
								<section className="wcgwWrapper RelatedRiskIcon cursorDefault">
									<span title={labels.wcgw}>
										<SVGICONS styleName="small" name={'question_triangle'} hoverText={labels.wcgw} />
									</span>
									<span>{totalParentsCount}</span>
								</section>
								<section className="controlWrapper cursorDefault">
									<span title={labels.control}>
										<Icon src={mapsIcTraffic24px} title={labels.control} />
									</span>
									<span>{totalChildrenCount}</span>
								</section>
							</section>
						)}
						{documentEntityId === entities.Engagement && (
							<section className="relatedObjectRight">
								<section className="wcgwWrapper cursorDefault">
									<span title={labels.boltIconTitle}>
										<Icon className="medium" size="16" src={IconoirCustomRiskBolt} title={labels.boltIconTitle} />
									</span>
									<span>{totalParentsCount}</span>
								</section>
							</section>
						)}
						{documentEntityId === entities.Control && (
							<section className="relatedObjectRight">
								<section className="wcgwWrapper cursorDefault">
									<span title={labels.relatedITapplicationSOs}>
										<SVGICONS styleName="medium" name={'shape'} hoverText={labels.relatedITapplicationSOs} />
									</span>
									<span>{totalParentsCount}</span>
								</section>
							</section>
						)}
						{!isSnapshotView && !isTargetEng && !userPreferences.isGuestUser ? (
							<section className="manageObjectsIcon" title={labels.manageObjects} onClick={loadManageObjectModel}>
								<SVGICONS styleName="medium" name="edit" hoverText={labels.manageObjects} />
							</section>
						) : (
							isfsroUpdated && <CompareSnapshotLabel snapshotObject={snapshotLabel} />
						)}
					</section>
				</section>
			</section>
			{showModal === true && (
				<ManageObjectsModal
					engagementId={engagementId}
					documentId={documentId}
					documentEntityId={documentEntityId}
					show={showModal}
					onClose={closeModal}
					section={section}
				/>
			)}
			{isLoading && relatedObjectExpanded ? (
				<LoadingIndicator view="inlineView" styleName="relatedDocuments-loading" />
			) : (
				relatedObjectExpanded && (
					<SectionRelatedObjectItem
						isSnapshotView={isSnapshotView}
						documentEntityId={documentEntityId}
						sectionRelatedObject={sectionsRelatedObjectsWithEntity}
					/>
				)
			)}
		</RelatedObjectWrapper>
	);
}

const RelatedObjectWrapper = styled.section`
	display: flex;
	flex-direction: column;
	margin: var(--px-10) var(--px-10) 0 var(--px-10);
	background-color: var(--neutrals-00white);
	border: var(--px-1) solid var(--neutrals-200);
	border-radius: var(--px-4);
	box-shadow: 0 var(--px-2) var(--px-4) 0 rgba(0, 0, 0, 0.5);
	.relatedDocuments-loading {
		margin-bottom: var(--px-10);
	}
	.accordionWrapper {
		display: block;
		width: 100%;
		padding: var(--px-10) var(--px-20) var(--px-10) var(--px-10);
		&:hover,
		&:focus {
			background-color: var(--neutrals-00white) !important;
		}
		.section-container {
			display: flex;
			width: 100%;
		}
		.relatedObject-Wrapper {
			display: flex;
			width: 100%;
			cursor: pointer;
			.relatedObject-container {
				display: flex;
				width: calc(100% - var(--px-40));
			}
		}
		.plusminusIcons {
			display: flex;
			align-items: center;
			transition: 0.5s;
			transition-property: height;
			svg {
				color: var(--neutrals-900);
				fill: none;
				path {
					fill: none;
				}
			}
		}
		.relatedObjectsText {
			display: flex;
			width: 100%;
			align-items: center;
			font-size: var(--px-14);
			line-height: var(--px-15);
			margin-left: var(--px-10);
			font-weight: bold;
		}
		.relatedObjectRight {
			margin-left: auto;
			display: flex;
			max-width: var(--px-170);
			.wcgwWrapper,
			.controlWrapper,
			.manageObjectsIcon {
				display: flex;
				width: var(--px-50);
				font-size: var(--px-12);
				color: var(--neutrals-700);
				margin-right: var(--px-10);
				svg {
					fill: var(--neutrals-700);
					margin-right: var(--px-5);
					width: var(--px-20) !important;
					height: var(--px-20) !important;
					vertical-align: middle;
				}
			}
			.cursorDefault {
				cursor: default;
				svg {
					cursor: default;
				}
			}
			.wcgwWrapper {
				&.RelatedRiskIcon {
					svg {
						width: var(--px-16);
						height: var(--px-16);
						color: var(--neutrals-800);
						path {
							fill: currentColor;
						}
					}
				}
			}
			.manageObjectsIcon {
				width: auto;
				margin: 0;
				svg {
					margin-top: var(--px-3);
				}
			}
		}
	}
	.SectionRelatedObjectWrapper {
		background-color: var(--neutrals-00white);
		padding-top: 0;
	}
	.motif-tree {
		.entity-content-main {
			overflow: unset !important;
		}
	}
`;
